module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n<ul class=\"remark push-prev\"\n    ko.foreach=\"validationRules\">\n    <li ko.text=\"message\"\n        ko.css=\"css\">\n    </li>\n</ul>\n";
